import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import PageRenderer from "./PageRenderer";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer"
import SiteWideBannerText from "./components/site-wide-banner-text/SiteWideBannerText";
import NotFound from "./components/404/NotFound"
import "./global.css";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://cms.gsdta.org"; // Fallback to local for development

console.log("process.env: ", process.env);
console.log("API Base URL: ", API_BASE_URL);

const App = () => {

  const [headerData, setHeaderData] = useState(null);
  const [kuralData, setKuralData] = useState(null);
  const [footerData, setFooterData] = useState(null);
  const [siteBannerData, setSiteBannerData] = useState({ texts: [] });
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    // Fetch common data (header, footer, routes)
    const fetchCommonData = async () => {
      try {
        const [headerResponse, kuralResponse, siteBannerResponse, footerResponse, routesResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/content/common/header.json`),
          axios.get(`${API_BASE_URL}/content/common/kural.json`),
          axios.get(`${API_BASE_URL}/content/common/site-banner-texts.json`),
          axios.get(`${API_BASE_URL}/content/common/footer.json`),
          axios.get(`${API_BASE_URL}/content/routes/routes.json`)
        ]);

        setHeaderData(headerResponse.data);
        setKuralData(kuralResponse.data);
        setSiteBannerData(siteBannerResponse.data);
        setFooterData(footerResponse.data);
        setRoutes(routesResponse.data.routes || []); // Assuming `routes` array is part of the response
      } catch (error) {
        console.error("Error fetching common data:", error);
      }
    };

    fetchCommonData();
  }, []);

  if (!headerData || !footerData) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="website-wrapper">
        <Header headerData={headerData} kuralData={kuralData}/>
        <div className="main-content">
          <SiteWideBannerText texts={siteBannerData.texts} />
          <Routes>
            {routes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<PageLoader contentPath={route.contentPath} />}
                />
              );
            })
            }
            {/* Catch-all route for undefined paths */}
            <Route path="*" element={<NotFound />} />

          </Routes>
        </div>
        <Footer footerData={footerData} />
      </div>
    </Router>
  );
}

// Component to dynamically load page data
const PageLoader = ({ contentPath }) => {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}${contentPath}`);
        setPageData(response.data);
      } catch (error) {
        console.error(`Error fetching page data for ${contentPath}:`, error);
      }
    };

    fetchPageData();
  }, [contentPath]);

  if (!pageData) {
    return <div>Loading...</div>;
  }

  return <PageRenderer pageData={pageData} />;
};

export default App;
